import { render, staticRenderFns } from "./SVGSprite.vue?vue&type=template&id=36e84500&"
var script = {}
import style0 from "./SVGSprite.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports